<template>
  <i-navbar size="sm" :collapse="false" fluid :am-header="categoryCode">
    <i-navbar-brand to="/">
      <h4>
        {{ projectName }} {{ categoryCode && categoryName ? `${categoryCode}/${categoryName?.toLowerCase()}` : ''}}
      </h4>
    </i-navbar-brand>
    <div class="_display:flex _align-items:center">
      <IButton
        v-if="$route.name !== 'signIn'"
        outline
        :color="
          colorMode === 'dark' || inkline.options.colorMode === 'dark'
          ? 'light'
          : 'dark'
        "
        size="sm"
        class="_margin-right:1/4"
        style="border:none"
        @click="$store.state.formula.isShowFormula = !$store.state.formula.isShowFormula"
      >
        Formula
      </IButton>
      <i-hamburger-menu v-if="$store.getters.isLoggedIn" animation="arrow-down" v-model="sidebar" />
    </div>
  </i-navbar>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import colorMode from '@/_mixins/colorMode'

export default {
  name: 'TheHeader',
  data: () => ({
    projectName: (document.location.href.includes('ditto') ? 'Ditto' : 'Tailornova')
  }),
  inject: ['inkline'],
  mixins: [colorMode],
  computed: {
    ...mapGetters('partCategories', ['categoryName']),
    ...mapState('ui', { sidebarState: state => state.sidebar }),
    sidebar: {
      get () { return this.sidebarState },
      set (val) { this.setSidebarState(val) }
    },
    categoryCode () {
      return this.$store.state.partCategories.selectedCategory
    }
  },
  methods: {
    ...mapMutations('ui', ['setSidebarState']),
    logout () {
      this.$store.dispatch('logout')
        .then(() => {
          this.$router.push('/')
        })
    }
  }
}
</script>

<style lang="scss">
  .navbar[am-header] {
    &.-light {
      ----background: var(--color--primary-20);
      ----border-color: var(--color--primary-30);
      ----item--background: var(--color--primary-20);
      ----item--background--hover: var(--color--primary-30);
    }
    &.-dark {
      ----background: var(--color--primary-70);
      ----border-color: var(--color--primary-60);
      ----item--background: var(--color--primary-70);
      ----item--background--hover: var(--color--primary-60);
    }
  }
  .navbar[am-header~='girlswear'] {
    &.-light {
      ----background: var(--color--info-20);
      ----border-color: var(--color--info-30);
      ----item--background: var(--color--info-20);
      ----item--background--hover: var(--color--info-30);
    }
    &.-dark {
      ----background: var(--color--info-70);
      ----border-color: var(--color--info-60);
      ----item--background: var(--color--info-70);
      ----item--background--hover: var(--color--info-60);
    }
  }
  .navbar[am-header~='boyswear'] {
    &.-light {
      ----background: var(--color--success-20);
      ----border-color: var(--color--success-30);
      ----item--background: var(--color--success-20);
      ----item--background--hover: var(--color--success-30);
    }
    &.-dark {
      ----background: var(--color--success-70);
      ----border-color: var(--color--success-60);
      ----item--background: var(--color--success-70);
      ----item--background--hover: var(--color--success-60);
    }
  }
  .navbar[am-header~='womenswear'] {
    &.-light {
      ----background: var(--color--secondary-20);
      ----border-color: var(--color--secondary-30);
      ----item--background: var(--color--secondary-20);
      ----item--background--hover: var(--color--secondary-30);
    }
    &.-dark {
      ----background: var(--color--secondary-70);
      ----border-color: var(--color--secondary-60);
      ----item--background: var(--color--secondary-70);
      ----item--background--hover: var(--color--secondary-60);
    }
  }
.logout {
  cursor: pointer;
}
</style>
